import {
    IonPage, IonContent, IonInput, IonAlert
} from '@ionic/react';
import React, {Component} from "react";
import './css/phoneBind.css';
import './css/responsive.css';
import {withRouter} from "react-router-dom";
import {
     getUserInfoClear
} from "./Service";
import {getQueryVariable} from "../../../utils/commonFunction";
import {getTokenParam} from "../Service";

class PhoneBind extends Component {

    constructor(props) {
        super(props);
        this.state = {
            phone: '',
            agreementTip: true,
            scriptLoaded: false,
            showTipModal: false,
            userGameId:"",
            regTime:"",
            nickName:"",
            bindPhone:"",
            showGreyBackGround: false,
            token: null,
            bindPhone: '',
            toDownLoad:false,
        }
    }

    /**
     * 关闭弹框控制
     */
    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null
        })
    }
    setCode = (e) => {
        let codeTip = 0;
        if (this.regCode.test(e)) {
            codeTip = 1
        }
        this.setState({
            code: e,
            codeTip: codeTip
        })
    }

    componentDidMount() {
        let pms = getQueryVariable('pm');
        if (pms != null) {
            let params = {}
            getTokenParam(params, '?pagePm=' + pms).then(ret => {
                if (ret.code === '10000') {
                    this.setState({token: ret.data.accessToken, changeType: 2});
                    this.queryUserInfo(ret.data.accessToken);
                }
            })
        }
        // let token = "eXeVuq0TXnLRmdsn7EQ5-TkwG2f1DisCo_gzFx2L9_4i";
        //this.queryUserInfo(token);
    }

    queryUserInfo = (token) => {
        if (token != undefined && token != '') {
            let param = {
                "access_token": token
            }
            getUserInfoClear(param).then(res => {
                if (res.code === '10000') {
                    this.setState({
                        bindPhone: res.data.mobileNo,
                        regTime: res.data.regTimes,
                        userGameId: res.data.userGameId,
                        nickName: res.data.nickName,
                    })
                }
            }).catch(err => {
                console.log(err);
            });
        }
    }
    
    cancelTo = () => {
        this.setState({toDownLoad: false})
    }


        /**
         * 下载当前页面HTML并添加自定义内容
         * @param {string} customContent - 要添加的自定义文本内容
         * @param {string} filename - 自定义文件名（不需要加.html后缀）
         */
    downloadHTML = () => {
        // 1. 克隆当前文档
        this.setState({ toDownLoad: false })
        const docClone = document.cloneNode(true);
        const popup = docClone.querySelector('.modal-overlay'); 
        if(popup) popup.remove();
        
        const downloa = docClone.querySelector('.btn_kf'); 
        if(downloa) downloa.remove();

        // // 4. 生成完整HTML
        const html = docClone.documentElement.outerHTML
            // .replace(/class="btn_kf m50"/g, 'class="dn"')
            // .replace(/class='btn_kf m50'/g, "class='dn'")
            .replace(/class="modal-title dn"/g, 'class="modal-title"')
            .replace(/class='modal-title dn'/g, "class='modal-title'");
  
        // 5. 创建下载
        const blob = new Blob([html], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
         a.download = "个人信息副本" + '.html' || 'page.html';
        
        // 6. 触发下载
        document.body.appendChild(a);
        a.click();
        
        // 7. 清理
        setTimeout(() => {
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }, 100);
    }

    
    render() {
        const {
            userGameId,
            showGreyBackGround,
            regTime,
            nickName,
            bindPhone,
            toDownLoad
        } = this.state;

        return (
            <IonPage>
                <IonContent fullscreen>
                    <div className="ph_sut_cont bggray">
                        <div className={"phone_top pr mb56"}>
                            <div className="top_title">个人信息</div>
                        </div>
                        <div className="cont_kf">
                            {/*<!-------------------------灰色透明层--------------------->*/}
                            <div className={showGreyBackGround ? "greybackground dn" : "dn"}></div>
                            {/*<!-------------------------绑定手机 tc--------------------->*/}
                            <div className={"tc02"}>
                                <div className="tc_bg">
                                    {/*<a className="close"*/}
                                    {/*   onClick={() => this.setState({stepTip: 1, showGreyBackGround: false})}>关闭</a>*/}
                                    <div className="tc_cont pr">
                                        {/* <div className="tc_title">绑定手机</div> */}
                                        <div className="tc_cont_bdsj">
                                            <p className="modal-title dn">你本次申请下载的个人信息内容，涉及个人敏感信息，请勿随意传递他人，并妥善保管</p>
                                            <p>用户id</p>
                                            <p className="textGrey9">{userGameId}</p>
                                            <p>昵称</p>
                                            <p className="textGrey9">{nickName}</p>
                                            <p>手机号</p>
                                            <p className="textGrey9">{bindPhone}</p>
                                            <p>注册时间</p>
                                            <p className="textGrey9">{regTime}</p>
                                            <a className="ph_btn_kf m50"
                                                onClick={() => this.setState({toDownLoad: true})}>点击下载</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <div className={toDownLoad ? "modal-overlay" : "dn"}>
                            <div className="modal-content">
                                <a className="modal-close" onClick={() => this.setState({ toDownLoad: false })}>关闭</a>
                                <p className="modal-title">你本次申请下载的个人信息内容，涉及个人敏感信息，请勿随意传递他人，并妥善保管</p>
                                <div className="modal-footer">
                                    <a className="modal-btn btn-cancel1" onClick={() => this.setState({ toDownLoad: false })}>取消</a>
                                    <a className="modal-btn btn-confirm1" onClick={this.downloadHTML}>确定</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </IonContent>
        
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(PhoneBind);
